<template>
  <div class="foot">
    <div class="foot-inner">
      <div class="foot-brand">
        <img class="foot-logo" src="../assets/image/logo2.png" alt="Viva Vida" />
        <a
          href="https://vivavida.onelink.me/v0MW/f0ue675w"
          target="_blank"
          rel="noopener"
          class="foot-download"
        >
          <img src="@/assets/image/xz_ico.png" alt="Descargar" />
        </a>
      </div>
      <div class="foot-contact">
        <div class="foot-contact-label">
          <img src="../assets/image/youxiang.png" alt="" /> Queja de cobranza:
        </div>
        <div class="foot-contact-email">vivavida.prestamos@gmail.com</div>
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/foot.scss";
export default {
  name: "footPage",
  data() {
    return {};
  },
};
</script>
